import React, { useState, useEffect, useRef, useCallback } from 'react';
import Dropdown from '../../../Components/CustomDropdown/customdropdown';
import { useToast } from '../../../Utils/toastContext';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import AddressAutocomplete from '../../../Components/addressInput/address-input';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomDropdownWithFetch from '../../../Components/CustomDropdown/custom-dropdown-fetchAPI';
import { debounce } from 'lodash';
import countriesData from '../../../Data/CountryCodes.json';
import DocumentPreview from '../../Create-Investment/documentpreview';
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
} from '../../../Redux/store/onboardingFormSlice';
import ReviewPopup from '../../../Components/onboarding/review-popup';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const PersonalInfo = ({ setCurrentStep, shareholderId }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const rejectedFields = useSelector(
    (state) => state.form.rejectedFieldsShareholder,
  );
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const stepStatus = useSelector((state) => state.form.stepStatusShareholder);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dobError, setDobError] = useState('');
  const [profilePayloadFile, setProfilePayloadFile] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [firstName, setfirstName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [lastName, setLastName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [middleName, setMiddleName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [formerNames, setFormerNames] = useState({
    verification_id: null,
    value: [],
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [newFormerName, setFormerName] = useState('');
  const [Dob, setDob] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [capturedFile, setCapturedFile] = useState(null);
  const [apIAddress, setApIAddress] = useState('');

  const [countryCodeData, setCountryCodeData] = useState([]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 14,
    label: 'Australia',
  });
  const [countryCode, setCountryCode] = useState({
    verification_id: null,
    value: {
      id: 14,
      name: 'Australia',
      risk_factor: 'low',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCountry, setRedCountry] = useState(null);
  const [redAddress, setRedAddress] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCity, setRedCity] = useState(null);
  const [redState, setRedState] = useState(null);
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState('/avatar.svg');
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [fileAvailable, setFileAvailable] = useState(false);
  const [fileAttorneyPath, setfileAttorneyPath] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [stream, setStream] = useState(null);
  const [animateCamera, setAnimateCamera] = useState(false);
  const { showToast } = useToast();
  const [fileAttorney, setFileAttorney] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [nameFromBirth, setNameFromBirth] = useState({
    verification_id: null,
    value: true,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [socialSecurityNumber, setSocialSecurityNumber] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [countries, setCountries] = useState([]);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const fieldLabelMap = {
    account_type_id: 'Account Type',
    applicant_country_id: "Applicant's Country",
    profile_picture_file: 'Profile Picture',
    first_name: 'First Name',
    last_name: 'Last Name',
    middle_name: 'Middle Name',
    is_birth_name: 'Is this your name from birth?',
    former_names: "Customer's Former Name(s)",
    dob: 'Date Of Birth',
    social_security_number: 'Social Security Number',
    address_id: 'Residential Address',
  };

  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const getAllLocationDetails = async () => {
    try {
      const response = await getLocation(
        redAddress.value.country &&
          redAddress.value.country.name &&
          redAddress.value.country.name !== ''
          ? redAddress.value.country.name
          : redAddress.value.country,
        redAddress.value.state &&
          redAddress.value.state.name &&
          redAddress.value.state.name !== ''
          ? redAddress.value.state.name
          : redAddress.value.state,
        redAddress.value.city &&
          redAddress.value.city.name &&
          redAddress.value.city.name !== ''
          ? redAddress.value.city.name
          : redAddress.value.city,
      );
      setRedCountry(response.country_id);
      setRedState(response.state_id);
      setRedCity(response.city_id);
    } catch (err) {
      setRedCountry(null);
      setRedState(null);
      setRedCity(null);
      showToast(err.message, 'error');
    }
  };

  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/users/countries?size=250`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            risk_factor: profile.risk_factor,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/api/v1/users/countries?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
          risk_factor: item.risk_factor,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/stakeholder/individual/personal-information/preview/${shareholderId}/verifications`,
      );

      if (response.status == 200) {
        if (response.data) {
          setfirstName(response.data.first_name);
          setLastName(response.data.last_name);
          setMiddleName(response.data.middle_name);
          setNameFromBirth(response.data.is_birth_name);
          setFormerNames(response.data.former_names);
          setDob(response.data.date_of_birth);
          setCountryCode(response.data.applicant_country);
          setpreselectedCountryCode({
            value: response.data.applicant_country.value.id,
            label: response.data.applicant_country.value.name,
          });
          setApIAddress(response.data.address.value);
          setRedAddress(response.data.address);
          setSocialSecurityNumber(response.data.social_security_number);
          setProfilePayloadFile(response.data?.profile_picture_file);
          setPreview(
            response.data.profile_picture_file?.value?.presigned_url == ''
              ? '/avatar.svg'
              : response.data.profile_picture_file?.value?.presigned_url,
          );
        } else {
          setfirstName({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setLastName({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setMiddleName({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setNameFromBirth({
            verification_id: null,
            value: true,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFormerNames({
            verification_id: null,
            value: [],
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setDob({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCountryCode({
            verification_id: null,
            value: {
              id: 14,
              name: 'Australia',
              risk_factor: 'low',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCountryCode({
            value: 14,
            label: 'Australia',
          });
          setApIAddress('');
          setRedAddress({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setSocialSecurityNumber({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setProfilePayloadFile({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreview('/avatar.svg');
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const formatDate = (date) => {
    if (!date) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    if (Dob.value && typeof Dob.value === 'string') {
      setDob({
        ...Dob,
        value: new Date(Dob.value), // convert string to Date
      });
    }
  }, [Dob.value]);
  const is18Plus = (date) => {
    const today = new Date();
    const dob = new Date(date);

    const age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (
      age > 18 ||
      (age === 18 && monthDiff > 0) ||
      (age === 18 && monthDiff === 0 && today.getDate() >= dob.getDate())
    ) {
      return true;
    }
    return false;
  };
  const handleNameFromBirth = (e) => {
    const value = e.target.value === 'true'; // convert string → boolean
    setNameFromBirth({
      ...nameFromBirth,
      value: value,
    });
  };
  const handleDobChange = (date) => {
    const value = date;

    if (!is18Plus(value)) {
      setDobError('You must be at least 18 years old');
    } else {
      setDobError('');
    }

    setDob({
      ...Dob,
      value,
    });
  };

  const handleDeleteFile = () => {
    setFileAttorney(null);
    setFileAvailable(false);
    setfileAttorneyPath({
      verification_id: null,
      value: '',
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const checkFieldsJA = () => {
    const validations = [
      {
        condition: !firstName.value,
        message: 'Please enter a valid first name',
      },
      { condition: !lastName.value, message: 'Please enter a valid last name' },
      {
        condition: !redAddress.value || !redCountry,
        message: 'Please enter a valid residential address',
      },
      { condition: !Dob.value, message: 'Please enter a valid date of birth' },
      { condition: !countryCode.value.id, message: 'Please select country' },
      {
        condition:
          nameFromBirth.value === false && formerNames.value.length === 0,
        message: 'Please enter at least one former name',
      },
    ];

    for (const { condition, message } of validations) {
      if (condition) {
        showToast(message, 'error');
        return true;
      }
    }

    return false;
  };
  const handleContinue = async (isFinal) => {
    if (isFinal) {
      if (!checkFieldsJA()) {
        setLoading(true);
        handlesave(isFinal);
      }
    } else {
      setLoading(true);
      handlesave(isFinal);
    }
  };

  const handleUploadFile = useCallback(
    debounce(async (e, file) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await fileUploadNew(capturedFile);
        if (response.status == '201') {
          const responseProfile = await fileUploadProfile(response.data);
          if (responseProfile.status == '200') {
            handleCloseCamera();
            toastMessage = {
              message: 'Profile picture uploaded successfully',
              type: 'success',
            };
          }
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [capturedFile], // Dependencies
  );
  const handleAddFormerName = (e) => {
    if (e.key === 'Enter' && newFormerName.trim() !== '') {
      setFormerNames((prev) => {
        const existingValues = Array.isArray(prev?.value)
          ? prev.value
          : prev?.value
            ? [prev.value]
            : [];

        return {
          ...prev,
          value: [...existingValues, newFormerName.trim()],
        };
      });

      setFormerName(''); // clear input
    }
  };

  const handleRemoveFormerName = (indexToRemove) => {
    setFormerNames((prev) => ({
      ...prev,
      value: prev.value.filter((_, index) => index !== indexToRemove),
    }));
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setCountryCode({
      ...countryCode,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
        risk_factor: selectedOption.risk_factor,
      },
    });
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg'];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast('Please upload an image in PNG or JPEG format.', 'error');
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast('File size must be less than 10MB.', 'error');
      return;
    }
    if (file) {
      let toastMessage = null;
      setLoading(true);
      try {
        const response = await fileUploadNew(file);
        if (response.status == '201') {
          const responseProfile = await fileUploadProfile(response.data);
          if (responseProfile.status == '200') {
            toastMessage = {
              message: 'Profile picture uploaded successfully',
              type: 'success',
            };
            const imageUrl = URL.createObjectURL(file);
            setPreview(imageUrl);
            setProfilePayloadFile({
              ...profilePayloadFile,
              value: response.data,
            });
          }
        }
      } catch (err) {
        setPreview('/avatar.svg');
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    event.target.value = '';
  };
  const fileUploadProfile = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/users/me/profile-picture`;
    let bodyData = { file_id: file.file_id, file_name: file.file_name };

    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const startCamera = async () => {
    setShowCamera(true);

    setTimeout(() => setAnimateCamera(true), 10); // trigger fade-in animation
    try {
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      setStream(newStream);
    } catch (err) {
      console.error('Camera access error:', err);
    }
  };
  // assign stream to video after it's rendered
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);

  const fileUploadNew = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append('file', file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const handleBack = () => {};
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/stakeholder/individual/personal-information/reset/${shareholderId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(
          `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
        );
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatusShareholder(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleUploadFileAttorney = useCallback(
    debounce(async (fileUploaded) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileUploaded);
        if (response.status == 201) {
          setfileAttorneyPath({
            ...fileAttorneyPath,
            value: response.data,
          });
          setFileAvailable(true);
        } else {
          setFileAvailable(false);
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        setFileAvailable(false);
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [fileAttorney], // Dependencies
  );
  const handleTakeSnap = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL('image/png');
    setPreview(dataUrl);
    // convert base64 -> file
    const file = dataURLtoFile(dataUrl, 'snapshot.png');
    setCapturedFile(file); // store for API payload
    // cleanup
    //  handleCloseCamera();
  };
  // utility function to convert base64 -> File object
  const dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };
  const handleCloseCamera = () => {
    setAnimateCamera(false); // start fade-out
    setTimeout(() => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
      }
      setShowCamera(false); // hide modal after animation
    }, 300); // match duration-300
  };
  const handleFileChangeAttorney = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAttorney(selectedFile);
        setLoading(true);
        handleUploadFileAttorney(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };

  const submitApplicationAPI = async (isFinal, payloadAddress) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording =
      stepStatus.length > 0 && stepStatus[0].status == 'DRAFT' ? true : false;
    let apiUrl = isOnbaording
      ? `${BASE_URL}/api/v1/onboarding/stakeholder/individual/personal-information/submit/${shareholderId}`
      : `${BASE_URL}/api/v1/onboarding/stakeholder/individual/personal-information/update/${shareholderId}`;
    let bodyData = {};
    bodyData = {
      first_name: firstName.value,
      last_name: lastName.value,

      profile_picture_file: profilePayloadFile.value
        ? {
            file_id: profilePayloadFile.value.file_id,
            file_name: profilePayloadFile.value.file_name,
          }
        : null,
      is_birth_name: nameFromBirth.value,
      former_names: formerNames.value,
      dob: formatDate(Dob.value),
      applicant_country_id: countryCode.value.id,
      address: payloadAddress,
      // social_security_number: socialSecurityNumber.value,
      is_submitted: isFinal,
    };
    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? 'POST' : 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };

  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      let payloadAddress = {};
      if (apIAddress != null) {
        payloadAddress = {
          address_line_1:
            apIAddress.address_line_1 == null
              ? apIAddress.google_address
              : apIAddress.address_line_1,
          address_line_2:
            apIAddress.address_line_2 == null
              ? null
              : apIAddress.address_line_2,
          city_id: apIAddress.city != null ? apIAddress.city.id : null,
          state_id: apIAddress.city != null ? apIAddress.city.state_id : null,
          country_id: redCountry,
          zip_code: apIAddress.postal_code,
          google_address: apIAddress.google_address,
        };
      } else {
        payloadAddress = {
          address_line_1:
            redAddress.value.street == ''
              ? redAddress.value.full
              : redAddress.value.street,
          address_line_2: redAddress.value.route,
          city_id: redCity,
          state_id: redState,
          country_id: redCountry,
          zip_code: redAddress.value.zip,
          google_address: redAddress.value.full,
        };
      }
      const response = await submitApplicationAPI(isFinal, payloadAddress);

      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(2);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseStatus = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/status/${shareholderId}`,
          );
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatusShareholder(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFieldsShareholder(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  useEffect(() => {
    getAllCountries();
  }, []);
  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[0].status != 'DRAFT') {
      getDetailsWithVerification();
    }
  }, [stepStatus]);
  useEffect(() => {
    if (
      updateFieldStatus &&
      stepStatus.length > 0 &&
      stepStatus[0].status != 'DRAFT'
    ) {
      getDetailsWithVerification();
    }
  }, [stepStatus, updateFieldStatus]);
  useEffect(() => {
    if (
      (redAddress.value && redAddress.value.country) ||
      (redAddress.value && redAddress.value.country.name)
    ) {
      getAllLocationDetails();
    }
  }, [redAddress]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {countryCode.value && countryCode.value.risk_factor == 'high' && (
          <div className="mb-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
            <img src="/tick-error.svg" alt="Info" className="w-5 h-5 mr-2" />
            <span>
              It looks like we’re
              <strong> not able to accept applications</strong> from this
              country at the moment.{' '}
            </span>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[0].status == 'IN_REVIEW' ||
            stepStatus[0].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[0].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.PERSONAL_INFORMATION?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.PERSONAL_INFORMATION.rejected_fields.length === 1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.PERSONAL_INFORMATION.rejected_fields.map(
                (field) => (
                  <span
                    key={field}
                    className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                  </span>
                ),
              )}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/profile-circle-black.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Personal Information</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="mb-2">
                <LabelWithStatus
                  id="firstName"
                  label={fieldLabelMap.account_type_id}
                  required={true}
                  fieldData={firstName}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="individual"
                  name="individual"
                  type="text"
                  value="Individual"
                  placeholder=""
                  disabled={true}
                  className={`rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                />
              </div>
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col md:px-4">
              <div className="">
                <CustomDropdownWithFetch
                  label={
                    <>
                      {fieldLabelMap.applicant_country_id}
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={countryCodeData}
                  search={true}
                  preselectedValue={preselectedCountryCode}
                  onSelect={handleSelectCountryCode}
                  colorLabel=""
                  fetchOptions={getCountries} // <-- pass fetch function, not options
                />
              </div>
            </div>
          </div>
          {countryCode.value && countryCode.value.risk_factor != 'high' && (
            <div className="bg-white">
              <div className="flex items-center border-b border-colour-custom space-x-2  pb-2"></div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {/* Profile Picture Section */}
                <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                  <LabelWithStatus
                    id="profilePic"
                    label={fieldLabelMap.profile_picture_file}
                    required={false}
                    fieldData={profilePayloadFile}
                    handleStatusClick={handleStatusClick}
                  />
                  <div className="mt-1">
                    <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PNG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      JPEG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      &#60; 10 MB
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-16 h-16 flex items-center justify-center">
                      <img
                        src={preview}
                        alt="Avatar"
                        className={`${
                          profilePayloadFile.status == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : ''
                        } w-14 h-14 rounded-full`}
                      />
                    </div>
                    <div className="flex flex-col space-y-1">
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                      <button
                        onClick={handleUploadClick}
                        disabled={profilePayloadFile.status == 'approved'}
                        className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full"
                      >
                        Upload from Device
                      </button>
                      <button
                        onClick={() => {
                          setPreview('');
                          setProfilePayloadFile({
                            ...profilePayloadFile,
                            value: null,
                          });
                          setCapturedFile(null);
                          startCamera();
                        }}
                        disabled={profilePayloadFile.status == 'approved'}
                        className="bg-[#375AE7] text-white text-xs px-3 py-1 rounded-full flex items-center justify-center gap-2"
                      >
                        <img
                          src="/camera-black.svg"
                          alt="Camera Icon"
                          className="w-4 h-4"
                        />
                        Take Snap
                      </button>
                    </div>
                  </div>
                  {/* Fullscreen Camera Modal */}
                  {showCamera && (
                    <div
                      className={`fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out ${
                        animateCamera ? 'opacity-100' : 'opacity-0'
                      }`}
                    >
                      <div
                        className={`relative transform transition-transform duration-300 ease-in-out bg-white rounded-xl p-4 w-full max-w-md flex flex-col items-center ${
                          animateCamera ? 'scale-100' : 'scale-90'
                        }`}
                      >
                        {/* Preview or Live Camera */}
                        {preview === '' ? (
                          <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            className="w-full h-auto rounded shadow-lg"
                          />
                        ) : (
                          <div className="relative w-full">
                            <img
                              src={preview}
                              alt="Avatar"
                              className="w-full h-auto rounded shadow-lg"
                            />
                            <button
                              onClick={() => {
                                setPreview('');
                                setProfilePayloadFile({
                                  ...profilePayloadFile,
                                  value: null,
                                });
                                setCapturedFile(null);
                                startCamera();
                              }}
                              className="absolute top-2 right-2 bg-white hover:bg-gray-100 p-1 rounded-full shadow-md transition"
                              aria-label="Remove preview"
                            >
                              <img
                                src="/trash.svg"
                                alt="Delete"
                                className="w-4 h-4"
                              />
                            </button>
                          </div>
                        )}

                        {/* Action Buttons */}
                        <div className="flex flex-wrap justify-center gap-4 mt-4">
                          <button
                            onClick={() => {
                              if (preview == '') {
                                setPreview('/avatar.svg');
                              }
                              if (
                                preview != '' &&
                                profilePayloadFile.value == null
                              ) {
                                setPreview('/avatar.svg');
                              }
                              handleCloseCamera();
                            }}
                            className="bg-white text-black border-black border-2 text-sm px-4 py-2 rounded-full"
                          >
                            Cancel
                          </button>
                          {preview === '' && (
                            <>
                              <button
                                onClick={handleTakeSnap}
                                className="bg-[#375AE7] text-white text-sm px-4 py-2 rounded-full"
                              >
                                Capture Photo
                              </button>
                            </>
                          )}
                          {preview !== '' && (
                            <>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  handleUploadFile(e);
                                }}
                                className="bg-[#375AE7] text-white text-sm px-4 py-2 rounded-full"
                              >
                                Upload Photo
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <canvas ref={canvasRef} className="hidden" />
                  <div className="mt-4">
                    <LabelWithStatus
                      id="firstName"
                      label={fieldLabelMap.first_name}
                      required={true}
                      fieldData={firstName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      value={firstName.value}
                      placeholder="Your First Name"
                      disabled={firstName.status == 'approved'}
                      className={`${
                        firstName.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setfirstName({
                          ...firstName,
                          value: e.target.value,
                        })
                      }
                    />
                    <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                      First Name as per identification documentation
                    </p>
                  </div>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="lastName"
                      label={fieldLabelMap.last_name}
                      required={true}
                      fieldData={lastName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      disabled={lastName.status == 'approved'}
                      value={lastName.value}
                      placeholder="Your Last Name"
                      className={`${
                        lastName.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setLastName({
                          ...lastName,
                          value: e.target.value,
                        })
                      }
                    />
                    <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                      Last Name as per identification documentation
                    </p>
                  </div>{' '}
                  <div className="mt-4">
                    <LabelWithStatus
                      id="middleName"
                      label={fieldLabelMap.middle_name}
                      required={false}
                      fieldData={middleName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="middleName"
                      name="middleName"
                      type="text"
                      value={middleName.value}
                      placeholder="Your Middle Name"
                      disabled={middleName.status == 'approved'}
                      className={`${
                        middleName.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setMiddleName({
                          ...middleName,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                {/* Date of Birth Section */}
                <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                  <div className="w-full">
                    <LabelWithStatus
                      id="Dob"
                      label={fieldLabelMap.dob}
                      required={true}
                      fieldData={Dob}
                      handleStatusClick={handleStatusClick}
                    />
                    <div className="w-full">
                      <DatePicker
                        selected={Dob.value}
                        onChange={handleDobChange}
                        dateFormat="dd/MM/yyyy"
                        minDate={new Date(1900, 0, 1)}
                        maxDate={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() - 18,
                            ),
                          )
                        }
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="scroll" // 🔥 FIX (instead of "select")
                        yearDropdownItemNumber={100} // 🔥 show 100 years
                        scrollableYearDropdown // 🔥 smooth scroll
                        placeholderText="Select Date of Birth"
                        wrapperClassName="w-full"
                        className={`w-full p-2 border rounded-md ${
                          Dob.status == 'rejected'
                            ? 'border-red-500'
                            : 'border-gray-300'
                        }`}
                      />

                      {/* Error Message */}
                      {dobError && (
                        <p className="text-red-500 text-xs mt-1">{dobError}</p>
                      )}
                    </div>
                  </div>
                  <div className="mt-4 flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                    <LabelWithStatus
                      id="birthName"
                      label={fieldLabelMap.is_birth_name}
                      required={true}
                      fieldData={nameFromBirth}
                      handleStatusClick={handleStatusClick}
                    />
                    {/* Radio Buttons */}
                    <div className="flex items-center gap-4">
                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="birthName"
                          value={true}
                          checked={nameFromBirth.value == true}
                          onChange={handleNameFromBirth}
                          disabled={nameFromBirth.status == 'approved'}
                          className={`${
                            nameFromBirth.status == 'rejected'
                              ? 'border-[#FF5050] border-2'
                              : 'border-gray-300'
                          } confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]`}
                        />
                        <span className="">Yes</span>
                      </label>

                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="birthName"
                          value={false}
                          checked={nameFromBirth.value == false}
                          onChange={handleNameFromBirth}
                          disabled={nameFromBirth.status == 'approved'}
                          className={`${
                            nameFromBirth.status == 'rejected'
                              ? 'border-[#FF5050] border-2'
                              : 'border-gray-300'
                          } confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]`}
                        />
                        <span className="">No</span>
                      </label>
                    </div>
                  </div>
                  <div className="">
                    <LabelWithStatus
                      id="formerNames"
                      label={fieldLabelMap.former_names}
                      required={false}
                      fieldData={formerNames}
                      handleStatusClick={handleStatusClick}
                    />
                    <div
                      className={`${
                        formerNames.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : 'border-gray-300'
                      } mt-1 border rounded-md  p-2 flex flex-wrap gap-2`}
                    >
                      {formerNames.value && formerNames.value.length > 0 && (
                        <>
                          {formerNames.value.map((formerName, index) => (
                            <div
                              key={index}
                              className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                            >
                              <span>{formerName}</span>
                              <button
                                type="button"
                                onClick={() => handleRemoveFormerName(index)}
                                className="ml-2 text-gray-700 hover:text-gray-700"
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </>
                      )}

                      <input
                        type="text"
                        value={newFormerName}
                        onChange={(e) => setFormerName(e.target.value)}
                        onKeyDown={handleAddFormerName}
                        placeholder="Add name"
                        className="border-none focus:outline-none flex-grow text-sm"
                        disabled={formerNames.status == 'approved'}
                      />
                    </div>
                  </div>
                </div>

                {/* Client ID Section */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                  <div className="">
                    <LabelWithStatus
                      id="ResidentialAddress"
                      label={fieldLabelMap.address_id}
                      required={true}
                      fieldData={redAddress}
                      handleStatusClick={handleStatusClick}
                    />
                    <AddressAutocomplete
                      value={
                        redAddress?.value?.full ||
                        apIAddress?.google_address ||
                        ''
                      }
                      disabled={redAddress.status == 'approved'}
                      className={
                        redAddress.status == 'rejected'
                          ? 'border-[#FF5050] border-2 w-full'
                          : 'w-full'
                      }
                      onSelect={(addr) => {
                        setApIAddress(null);
                        setRedAddress({
                          ...redAddress,
                          value: addr,
                        });
                      }}
                    />
                  </div>
                  <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                    PLEASE MAKE SURE THE PROVIDED ADDRESS MATCHES THE DOCUMENT
                    PROOFS YOU PROVIDE.
                  </p>
                  {countryCode.value && countryCode.value.id == 233 && (
                    <div className="mt-4">
                      <LabelWithStatus
                        id="socialSecurityNumber"
                        label={fieldLabelMap.social_security_number}
                        required={true}
                        fieldData={socialSecurityNumber}
                        handleStatusClick={handleStatusClick}
                      />
                      <input
                        id="socialSecurityNumber"
                        name="socialSecurityNumber"
                        type="text"
                        value={socialSecurityNumber.value}
                        placeholder="Your Social Security Number"
                        disabled={socialSecurityNumber.status == 'approved'}
                        className={`${
                          socialSecurityNumber.status == 'rejected'
                            ? 'border-[#FF5050] border-2'
                            : ''
                        } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) =>
                          setSocialSecurityNumber({
                            ...socialSecurityNumber,
                            value: e.target.value,
                          })
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {countryCode.value && countryCode.value.risk_factor != 'high' && (
        <footer className=" bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
          {stepStatus.length > 0 &&
            stepStatus[0].status != 'COMPLETED' &&
            stepStatus[0].status != 'APPROVED' &&
            stepStatus[0].status != 'IN_REVIEW' && (
              <>
                <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                  <ConfirmResetButton
                    onConfirm={handleReset}
                    isReset={true}
                    isBack={false}
                    onBack={handleBack}
                  />
                </div>
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>

                  <ConfirmContinueButton
                    onContinue={() => handleContinue(true)}
                    buttonText="Continue"
                    confirmTitle="Save Section"
                    confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                  />
                </div>
              </>
            )}
          {stepStatus.length > 0 &&
            (stepStatus[0].status == 'COMPLETED' ||
              stepStatus[0].status == 'APPROVED' ||
              stepStatus[0].status == 'IN_REVIEW') && (
              <>
                <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                  <ConfirmResetButton
                    onConfirm={handleReset}
                    isReset={false}
                    isBack={true}
                    onBack={handleBack}
                  />
                </div>
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      setCurrentStep(2);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Next</span>
                  </button>
                </div>
              </>
            )}
        </footer>
      )}
    </div>
  );
};

export default PersonalInfo;
